import React, { useCallback, useMemo, useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { EventModalActions } from 'store/actionCreators'
import { sendWebViewMsg } from 'utils/bridge'

// import charmdenImg from 'images/event/charmden_popup.png'
// import charmdenImg from 'images/event/charmden_popup_for_mom.png'
import charmdenImg from 'images/event/charmden_popup_apple.png'
import { useHistory } from 'react-router-dom'

const CharmdenModal = () => {
  const history = useHistory()

  const { eventModalVisible } = useSelector((state) => state.eventModal)

  const [cookies, setCookies] = useCookies()

  const COOKIE_NAME = 'disable_event_modal'

  const isMain = useMemo(() => history.location.pathname === '/', [history])
  const disableEventModal = useMemo(() => {
    if (cookies[`${COOKIE_NAME}`]) return true
    return false
  }, [cookies])

  const handleDisableEventModal = useCallback(() => {
    if (!disableEventModal) {
      const cookieDomain = process.env.REACT_APP_ENV === 'dev' ? 'localhost' : '.motiners.com'
      const cookieMaxAge = process.env.REACT_APP_ENV === 'dev' ? 60 : 60 * 60 * 24
      setCookies(`${COOKIE_NAME}`, 'true', {
        path: '/',
        maxAge: cookieMaxAge,
        domain: cookieDomain,
      })
      EventModalActions.updateEventModalState({ eventModalVisible: false })
      sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
    }
  }, [disableEventModal, setCookies])

  const closeEventModal = useCallback(() => {
    EventModalActions.updateEventModalState({ eventModalVisible: false })
  }, [])

  useEffect(() => {
    if (!disableEventModal) {
      EventModalActions.updateEventModalState({ eventModalVisible: true })
    } else {
      EventModalActions.updateEventModalState({ eventModalVisible: false })
    }
  }, [disableEventModal])

  if (!eventModalVisible || disableEventModal || !isMain) return null
  return (
    <Background>
      <ModalBody>
        <PopupImgBlock>
          <Router
            onClick={() => {
              const url =
                process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'dev'
                  ? '/motishop/product/179'
                  : '/motishop/product/135'
              history.push(url)
            }}
          >
            <PopupImg src={charmdenImg} alt="branddak event" />
          </Router>
        </PopupImgBlock>
        <ButtonGroup>
          <ButtonStyle onClick={handleDisableEventModal}>오늘 그만 보기</ButtonStyle>
          <ButtonStyle onClick={closeEventModal}>닫기</ButtonStyle>
        </ButtonGroup>
      </ModalBody>
    </Background>
  )
}

const Background = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 500;
`

const ModalBody = styled.div`
  background: none;
  width: calc(100vw * (270 / 375));
`

const PopupImgBlock = styled.div`
  border-radius: calc(100vw * (10 / 375));
  overflow: hidden;
`

const Router = styled.span`
  width: 100%;
  height: auto;
`

const PopupImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
`

const ButtonStyle = styled.button`
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (17 / 375));
  color: #fff;
  padding: calc(100vw * (18 / 375)) 0;
`

export default CharmdenModal
